import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const InputTextTailwindThemes = {
  inputtext: {
    root: ({ context, props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'm-0',
        'font-sans text-black bg-white border transition-colors duration-200 appearance-none rounded-sm',
        'placeholder:text-fletchers-gray-200 placeholder:text-[0.75rem]',
        {
          'focus:outline-none focus:outline-offset-0 focus:border-fletchers-gray-200': !context.disabled,
          'hover:border-fletchers-gray-200': !props.invalid && !context.disabled,
          'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
          'border-fletchers-gray-110': !props.invalid,
          'border-fletchers-red-500 hover:border-fletchers-red-500/80 focus:border-red-800':
            props.invalid && !context.disabled,
          'border-fletchers-red-500/50': props.invalid && context.disabled,
        },
        {
          'px-1.5 py-0.75 text-xs': props.size === 'small',
          'px-1.75 py-1 text-[0.75rem]': !props.size || typeof props.size === 'number',
          'px-2 py-1.25 text-lg': props.size === 'large',
        },
        // For each input wrapped with IconField you will need to add styling
        'focus:[:has(~&)]:text-black focus:[&~[data-pc-name="inputicon"]]:text-black',
        {
          '[:has(~&)]:-mt-1.25 [:has(~&)]:text-xs [&~[data-pc-name="inputicon"]]:-mt-1.25 [&~[data-pc-name="inputicon"]]:text-xs':
            props.size === 'small',
          '[:has(~&)]:left-1.5 [&~[data-pc-name="inputicon"]]:left-1.5':
            props.size === 'small' && context.iconPosition === 'left',
          '[:has(~&)]:right-1.5 [&~[data-pc-name="inputicon"]]:right-1.5':
            props.size === 'small' && context.iconPosition === 'right',
          '[:has(~&)]:-mt-2 [:has(~&)]:text-base [&~[data-pc-name="inputicon"]]:-mt-2 [&~[data-pc-name="inputicon"]]:text-base':
            props.size === 'large',
          '[:has(~&)]:left-3 [&~[data-pc-name="inputicon"]]:left-3':
            props.size === 'large' && context.iconPosition === 'left',
          '[:has(~&)]:right-3 [&~[data-pc-name="inputicon"]]:right-3':
            props.size === 'large' && context.iconPosition === 'right',
        },
        {
          'pl-7': context.iconPosition === 'left',
          'pr-7': context.iconPosition === 'right',
          'pl-5.5': props.size === 'small' && context.iconPosition === 'left',
          'pr-5.5': props.size === 'small' && context.iconPosition === 'right',
          'pl-9': props.size === 'large' && context.iconPosition === 'left',
          'pr-9': props.size === 'large' && context.iconPosition === 'right',
        },
      ),
    }),
  },
};
